import React, { Component } from 'react';
import { connect } from "react-redux";

import { Row, Col } from 'react-bootstrap';
import HomeButton from './buttons/HomeButton'
import LegalAreasButton from './buttons/LegalAreasButton'
import WorksButton from './buttons/WorksButton'
import ContactButton from './buttons/ContactButton'

class CurriculumVitae extends Component {
    render() {

        let title1;
        let text1;
        let title2
        let text2;
        let text3;
        switch (this.props.language) {
            case 'English':
                title1 = 'Education:'
                text1 =
                    <div>
                        <h4>- Faculty of Law in Zagreb, graduated in 1996</h4>
                        <h4>- Faculty of Law in Zagreb, postgraduate studies in commercial law, master's degree in 2001</h4>
                    </div>
                title2 = 'Professional experience:'
                text2 =
                    <div>
                        <h4>- legal intern from 05/1996 to 02/1997 with lawyer Nikša Đurić, Zagreb</h4>
                        <h4>- judical trainee from 03/1997 to 04/1998, Commercial Court in Zagreb</h4>
                        <h4>- secretary of the City of Obrovac from 05/1998 to 05/2000, City of Obrovac</h4>
                        <h4>- judge of the Municipal Court in Benkovac from 06/2000 to 05/2003</h4>
                        <h4>- judge of the Municipal Court in Zadar from 06/2003 to 06/2005</h4>
                        <h4>- attorney at law in Zadar from 07/2005</h4>
                        <h4>- took over the attorney's office of late Branko Zrilic (father) 10/2005</h4>
                    </div>
                text3 = 'Languages: Croatian and English'
                break
            default:
                title1 = 'Obrazovanje:'
                text1 =
                    <div>
                        <h4>- Pravni fakultet u Zagrebu, diplomirao 1996. god.</h4>
                        <h4>- Pravni fakultet u Zagrebu, postiplomski studij iz trgovačkog prava, magistrirao 2001. god.</h4>
                    </div>
                title2 = 'Profesionalno iskustvo:'
                text2 =
                    <div>
                        <h4>- odvjetnički vježbenik od 05/1996. do 02/1997. kod odvjetnika Nikše Đurića, Zagreb</h4>
                        <h4>- sudački vježbenik od 03/1997 do 04/1998, Trgovački sud u Zagrebu</h4>
                        <h4>- tajnik Grada Obrovca od 05/1998 do 05/2000, Grad Obrovac</h4>
                        <h4>- sudac Općinskog suda u Benkovcu od 06/2000 do 05/2003</h4>
                        <h4>- sudac Općinskog suda u Zadru od 06/2003 do 06/2005</h4>
                        <h4>- odvjetnik u Zadru od 07/2005</h4>
                        <h4>- preuzeo ured pok. odvj. Branka Zrilića (otac) 10/2005</h4>
                    </div>
                text3 = 'Jezici: Hrvatski i Engleski'
        }

        return (
            <div>
                <Row>
                    <HomeButton />
                    <LegalAreasButton />
                    <WorksButton />
                    <ContactButton />
                </Row>
                <br />
                <h2>Curriculum vitae:</h2>
                <hr />
                <Row>
                    <Col md={3}>
                        <h4>{title1}</h4>
                    </Col>
                    <Col md={9}>
                        {text1}
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col md={3}>
                        <h4>{title2}</h4>
                    </Col>
                    <Col md={9}>
                        {text2}
                    </Col>
                </Row>
                <hr />
                <h4>{text3}</h4>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { 
      language: state.language 
    };
  };

export default connect(mapStateToProps, null)(CurriculumVitae);


// WEBPACK FOOTER //
// ./src/screens/CurriculumVitae.js